import { faPen, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { Component } from 'react';
import ValidationText from '../../utils/validation/ValidationText.js';
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown.js';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import AccountServices from '../../services/axioServices/apiServices/AccountServices.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';

class GstPurchaseEntryWithoutInventory extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.accountServices = new AccountServices();
        this.state = {
            isGridView: true,
            isEditing: false,
            isLoading: false,
            tableStatus: "",
            gstPurchaseEntryWithoutInventoryList: [],
            filterDetails: {
                partyName: "",
                arrangedBy: "Select",

            },
            invoiceDetails: {
                gstPurchaseEntryWithoutInventoryId: "",
                srNo: "",
                invoiceNo: "",
                invoiceDate: "",
                invoiceType: "",
                partyId: "",
                purchasedItemName: "",
                amount: "",
                hsnCodeName: "",
                sgst: "",
                cgst: "",
                igst: "",
                ugst: "",
                taxableAmount: "",
                sgstAmount: "",
                cgstAmount: "",
                igstAmount: "",
                ugstAmount: "",
                freight: "",
                others: "",
                roundOff: "",
                grandTotal: "",
                pendingAmount: ""
            },
            partyDropdownList: [],
            hsnCodeList: [],
            arrangedByList: [
                { arrangedBy: "Ser. No.", value: "srNo" },
                { arrangedBy: "Invoice No.", value: "invoiceNo" },
                { arrangedBy: "Invoice Date", value: "InvoiceDate" },
                { arrangedBy: "Party Name", value: "partyName" },


            ],
            invoiceTypeList: [
                { invoiceType: "Text Invoice", value: "textInvoice" },
            ],
            validationRules: {
                partyId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "party name"
                        ),
                    },
                ],
                hsnCodeName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "hsn code"
                        ),
                    },
                ],
                invoiceNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "invoice No"
                        ),
                    },
                ],
                amount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "amount"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        this.getAllPurchaseEntryWithoutInventory()
    }

    getAllPurchaseEntryWithoutInventory = () => {
        this.setState({ tableStatus: "Loading..." })
        let request = this.state.filterDetails
        this.accountServices.getAllPurchaseEntryWithoutInventory(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                if (response.responseData.length === 0) {
                    this.setState({ tableStatus: "No Record Found" })
                } else {
                    this.setState({ tableStatus: "" })
                }
                this.setState({ gstPurchaseEntryWithoutInventoryList: response.responseData }, () => {
                    this.getAllPartyDropdown()
                })
            } else {
                this.setState({ tableStatus: "" })
                this.getAllPartyDropdown();
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                    email: item.email,
                }));
                this.setState({ partyDropdownList: dropdownItems }, () => {
                    this.getAllHSNCode()
                }

                );
            } else {
                this.getAllHSNCode()
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };
    getAllHSNCode = () => {
        this.commonServices.getAllHSNCode().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.HSNCode,
                    value: item._id,
                    sgstRate: item.SGST,
                    cgstRate: item.CGST,
                    igstRate: item.IGST,
                    utgstRate: item.UTGST
                }));
                this.setState({ hsnCodeList: dropdownItems });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };
    closeGridView = () => {
        this.setState({ isGridView: false });
    };

    openGridView = () => {
        this.resetForm();
        this.setState({ isGridView: true, isEditing: false });
    };
    resetForm = () => {
        let validState = this.state.validState
        validState.error = {}
        validState.isValid = true
        let Fdetails = this.state.filterDetails;
        Fdetails.partyName = "";
        Fdetails.arrangedBy = "srNo";
        let Idetails = this.state.invoiceDetails;
        Idetails.srNo = "";
        Idetails.invoiceNo = "";
        Idetails.invoiceDate = "";
        Idetails.invoiceType = "";
        Idetails.partyId = "";
        Idetails.purchasedItemName = "";
        Idetails.amount = "";
        Idetails.hsnCodeName = "";
        Idetails.sgst = "";
        Idetails.cgst = "";
        Idetails.igst = ""
        Idetails.taxableAmount = ""
        Idetails.sgstAmount = "";
        Idetails.cgstAmount = "";
        Idetails.igstAmount = "";
        Idetails.freight = ""
        Idetails.others = ""
        Idetails.grandTotal = ""
        Idetails.roundOff = ""
        Idetails.gstPurchaseEntryWithoutInventoryId = ""
        this.setState({
            invoiceDetails: Idetails, filterDetails: Fdetails, validState: validState
        }, () => {
            this.getAllPurchaseEntryWithoutInventory()
        });
    };
    handleChange = (event, name, section) => {
        let value = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = value.toUpperCase();
            this.setState({ filterDetails: details }, () => {
                this.getAllPurchaseEntryWithoutInventory()
            });
        }
        else if (section === "invoiceDetails") {
            let details = this.state.invoiceDetails;
            details[name] = value.toUpperCase();
            this.setState({ invoiceDetails: details }, () => {
                this.calculateItemAmount()
            });
        }
    };

    handleDropDownChange = (event, name, section) => {
        const select = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = select;
            this.setState({ filterDetails: details }, () => {
                this.getAllPurchaseEntryWithoutInventory()
            })
        }
        else if (section === "invoiceDetails") {
            let details = this.state.invoiceDetails;
            details[name] = select;
            this.setState({ invoiceDetails: details });
        }
    };
    setFilterParameters = (selected, drpIdentity, section) => {
        let details = this.state.invoiceDetails;
        if (drpIdentity === 'hsnCodeId') {
            details.hsnCodeName = selected.label
            details.sgst = selected.sgstRate
            details.cgst = selected.cgstRate
            details.igst = selected.igstRate

        }
        details[drpIdentity] = selected.value;

        this.setState({ invoiceDetails: details });
    };

    getGSTPurchseWithoutInventoryEntrySRNo = () => {
        this.accountServices.getGSTPurchseWithoutInventoryEntrySRNo().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let details = this.state.invoiceDetails
                details.srNo = response.responseData.srNo
                details.invoiceDate = moment(new Date()).format('yyyy-MM-DD')
                this.setState({ invoiceDetails: details }, () => {
                    this.closeGridView()
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    calculateItemAmount = () => {
        let invoiceDetails = this.state.invoiceDetails
        invoiceDetails.taxableAmount = Number(invoiceDetails.amount)
        invoiceDetails.sgstAmount = Number(invoiceDetails.sgst) * Number(invoiceDetails.taxableAmount) / 100
        invoiceDetails.cgstAmount = Number(invoiceDetails.cgst) * Number(invoiceDetails.taxableAmount) / 100
        invoiceDetails.igstAmount = Number(invoiceDetails.igst) * Number(invoiceDetails.taxableAmount) / 100
        invoiceDetails.ugstAmount = Number(invoiceDetails.ugst) * Number(invoiceDetails.taxableAmount) / 100
        invoiceDetails.grandTotal = (Number(invoiceDetails.taxableAmount) + Number(invoiceDetails.sgstAmount) + Number(invoiceDetails.cgstAmount) + Number(invoiceDetails.ugstAmount) + Number(invoiceDetails.igstAmount)).toFixed(2)
        invoiceDetails.grandTotal = Number(invoiceDetails.grandTotal) + (Number(invoiceDetails.freight) || 0) + (Number(invoiceDetails.others) || 0)
        invoiceDetails.roundOff = (invoiceDetails.grandTotal % 1).toFixed(2);
        invoiceDetails.grandTotal = Math.round(invoiceDetails.grandTotal).toFixed(2);
        invoiceDetails.pendingAmount = Math.round(invoiceDetails.grandTotal)
        this.setState({ invoiceDetails: invoiceDetails })
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.invoiceDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    addEditGSTPurchaseEntryWithoutInventory = () => {
        let isValidAllFields = this.isValidAllFields()
        if (isValidAllFields) {
            this.setState({ isLoading: true }, () => {
                let request = this.state.invoiceDetails
                this.accountServices.addEditGSTPurchaseEntryWithoutInventory(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        let details = this.state.invoiceDetails
                        details.gstPurchaseEntryWithoutInventoryId = response.responseData._id
                        this.setState({ invoiceDetails: details }, () => {
                            this.getAllPurchaseEntryWithoutInventory()
                            this.setState({ isGridView: true, isLoading: false, isEditing: false })
                            this.resetForm()
                        })
                        this.SwalServices.Success(response.Message)
                    } else {
                        this.setState({ isLoading: false })
                        this.SwalServices.Error(response.Message);
                    }
                });
            })
        }
    }

    getGSTPurchaseEntryWithoutInventoryById = (id) => {
        this.accountServices.getGSTPurchaseEntryWithoutInventoryById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData
                let details = this.state.invoiceDetails
                details.srNo = res.srNo
                details.gstPurchaseEntryWithoutInventoryId = res._id
                details.invoiceNo = res.invoiceNo
                details.invoiceDate = moment(res.invoiceDate).format('yyyy-MM-DD')
                details.partyId = res.partyId._id
                details.freight = res.freight
                details.others = res.others
                details.roundOff = res.roundOff
                details.sgst = res.sgst
                details.cgst = res.cgst
                details.igst = res.igst
                details.ugst = res.ugst
                details.grandTotal = Number(res.grandTotal).toFixed(2)
                details.pendingAmount = res.pendingAmount
                details.invoiceType = res.invoiceType
                details.purchasedItemName = res.purchasedItemName
                details.amount = res.amount
                details.hsnCodeName = res.hsnCodeName
                details.taxableAmount = res.taxableAmount
                details.sgstAmount = res.sgstAmount
                details.cgstAmount = res.cgstAmount
                details.igstAmount = res.igstAmount
                details.ugstAmount = res.ugstAmount
                this.setState({ invoiceDetails: details }, () => {
                    this.setState({ isGridView: false, isEditing: true })
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    deleteGSTPurchaseEntryWithoutInventoryById = (id) => {
        this.SwalServices.Confirm(
            "",
            ``,
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text,
            `Are you sure you want to delete this Purchase Entry?`
        ).then((response) => {
            if (response === true) {
                this.accountServices.deleteGSTPurchaseEntryWithoutInventoryById(id).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        this.getAllPurchaseEntryWithoutInventory()
                        this.SwalServices.Success(response.Message);
                    } else {
                        this.SwalServices.Error(response.Message);
                    }
                });
            }
        });
    }

    render() {
        return (
            <div className='GstPurchaseEntryWithoutInventory-page'>
                {this.state.isGridView === true ? (
                    <>
                        {/* 1. Item Search  */}
                        <div className="item-search">
                            <div className="item-grp flex gap-2.5 mb-2.5 w-[60%]">
                                <div className="search-grp w-[60%]">
                                    <label>Party Name</label>
                                    <input
                                        type="text"
                                        id="partyName"
                                        name="partyName"
                                        className="inputFocus"
                                        autocomplete="off"
                                        value={this.state.filterDetails.partyName}
                                        onChange={(event) =>
                                            this.handleChange(event, "partyName", "filterDetails")
                                        }
                                    />
                                </div>

                                <div className="search-grp w-[40%]">
                                    <label>Arranged By</label>
                                    <select
                                        name="arrangedBy"
                                        className="w-full"
                                        value={this.state.filterDetails.arrangedBy && this.state.filterDetails.arrangedBy !== 'Select' && this.state.arrangedByList.find(
                                            (party) => party.value === this.state.filterDetails.arrangedBy
                                        ).value}
                                        onChange={(event) =>
                                            this.handleDropDownChange(
                                                event,
                                                "arrangedBy",
                                                "filterDetails"
                                            )
                                        }
                                    >
                                        <option>Select</option>
                                        {this.state.arrangedByList.map((x, key) => (
                                            <option key={key} value={x.value}>
                                                {x.arrangedBy}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                            </div>
                            <button className="add-btn" onClick={() => this.getGSTPurchseWithoutInventoryEntrySRNo()}>
                                Add New
                            </button>
                        </div>

                        {/* 2. Item tabel  */}
                        <div className="itemList-table">
                            <div className="table-container" style={{ height: "calc(100vh - 180px)" }}>
                                <table className="itemList">
                                    <thead>
                                        <tr>
                                            <td className='w-[15%]'>Ser. No.</td>
                                            <td className='w-[15%]'>Invoice No.</td>
                                            <td className='w-[15%]'>Invoice Date</td>
                                            <td className='w-[20%]'>Party Name</td>
                                            <td className='w-[20%]'>Net Amount</td>
                                            <td className="w-[15%]" style={{ textAlign: "center" }}>Action</td>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.gstPurchaseEntryWithoutInventoryList && this.state.gstPurchaseEntryWithoutInventoryList.length > 0 ? (
                                            this.state.gstPurchaseEntryWithoutInventoryList.map((item, key) => (
                                                <tr key={key}>
                                                    <td>{item.srNo}</td>
                                                    <td>{item.invoiceNo}</td>
                                                    <td>{moment(item.invoiceDate).format('DD MMM yyyy')}</td>
                                                    <td>{item.partyName}</td>
                                                    <td>{Number(item.grandTotal).toFixed(2)}</td>
                                                    <td className='!text-center'>
                                                        <button
                                                            className="search-btn"
                                                            onClick={() => this.getGSTPurchaseEntryWithoutInventoryById(item._id)}
                                                        >
                                                            <FontAwesomeIcon icon={faPen} />
                                                        </button>
                                                        <button
                                                            className="cancel-btn"
                                                            onClick={() => this.deleteGSTPurchaseEntryWithoutInventoryById(item._id)}
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : this.state.gstPurchaseEntryWithoutInventoryList
                                            && this.state.gstPurchaseEntryWithoutInventoryList.length === 0
                                            && this.state.tableStatus !== "" ? (
                                            <tr>
                                                <td colSpan={6} style={{ textAlign: "center", fontSize: "16px" }}>
                                                    {this.state.tableStatus}
                                                </td>
                                            </tr>
                                        ) : this.state.gstPurchaseEntryWithoutInventoryList
                                            && this.state.gstPurchaseEntryWithoutInventoryList.length === 0
                                            && this.state.tableStatus === "" ? null : ""}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                ) : null}

                {this.state.isGridView === false ? (
                    <>
                        <div className="item-form ">
                            <div className="form-table">
                                <div className="item-grp !flex !gap-2.5 !mb-3">
                                    <div className="input-grp w-full">
                                        <label>Ser. No.</label>
                                        <input
                                            type="text"
                                            id="srNo"
                                            name="srNo"
                                            disabled
                                            autocomplete="off"
                                            value={this.state.invoiceDetails.srNo}
                                            onChange={(event) =>
                                                this.handleChange(event, "srNo", "invoiceDetails")
                                            }
                                        />
                                    </div>
                                    <div className="input-grp w-full">
                                        <label>Invoice No.</label>
                                        <input
                                            type="text"
                                            id="invoiceNo"
                                            name="invoiceNo"
                                            className={`inputFocus ${this.state.validState?.error?.invoiceNo ? "errorInput" : ""}`}
                                            autocomplete="off"
                                            value={this.state.invoiceDetails.invoiceNo}
                                            onChange={(event) =>
                                                this.handleChange(event, "invoiceNo", "invoiceDetails")
                                            }
                                        />
                                        {/* <ValidationText error={this.state.validState.error.invoiceNo} /> */}
                                    </div>
                                    <div className="input-grp w-full">
                                        <label>Invoice Date</label>
                                        <input
                                            type="date"
                                            id="invoiceDate"
                                            name="invoiceDate"
                                            className="inputFocus w-full"
                                            autocomplete="off"
                                            value={this.state.invoiceDetails.invoiceDate}
                                            onChange={(event) =>
                                                this.handleChange(event, "invoiceDate", "invoiceDetails")
                                            }
                                        />
                                    </div>
                                    <div className="search-grp w-full">
                                        <label>Invoice Type</label>
                                        <select
                                            name="invoiceType"
                                            className="w-full"
                                            value={this.state.invoiceDetails.invoiceType && this.state.invoiceDetails.invoiceType !== 'Select' && this.state.invoiceTypeList.find(
                                                (party) => party.value === this.state.invoiceDetails.invoiceType
                                            ).value}
                                            onChange={(event) =>
                                                this.handleDropDownChange(
                                                    event,
                                                    "invoiceType",
                                                    "invoiceDetails"
                                                )
                                            }
                                        >
                                            <option>Select</option>
                                            {this.state.invoiceTypeList.map((x, key) => (
                                                <option key={key} value={x.value}>
                                                    {x.invoiceType}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="item-grp !flex !gap-2.5 !mb-3">
                                    <div className="input-grp min-w-[40%]">
                                        <label>Party Name</label>
                                        <MultiSelectDropdown
                                            drpIdentity="partyId"
                                            options={this.state.partyDropdownList}
                                            className={`inputFocus ${this.state.validState?.error?.partyId ? "errorInput" : ""}`}
                                            closeMenuOnSelect={true}
                                            hideSelectedOptions={false}
                                            onChange={(selected) =>
                                                this.setFilterParameters(selected, "partyId")
                                            }
                                            allowSelectAll={false}
                                            value={this.state.partyDropdownList.filter(
                                                (party) =>
                                                    party.value === this.state.invoiceDetails.partyId
                                            )}
                                        />
                                        {/* <ValidationText error={this.state.validState.error.partyId} /> */}
                                    </div>
                                    <div className="input-grp w-full">
                                        <label>Purchased Item Name</label>
                                        <input
                                            type="text"
                                            id="purchasedItemName"
                                            name="purchasedItemName"
                                            className='inputFocus'
                                            autoComplete='off'
                                            value={this.state.invoiceDetails.purchasedItemName}
                                            onChange={(event) =>
                                                this.handleChange(event, "purchasedItemName", "invoiceDetails")
                                            }
                                        />
                                    </div>
                                    <div className="input-grp w-full">
                                        <label>Amount</label>
                                        <input
                                            type="number"
                                            id="amount"
                                            name="amount"
                                            className={`inputFocus ${this.state.validState?.error?.amount ? "errorInput" : ""}`}
                                            autoComplete='off'
                                            value={this.state.invoiceDetails.amount}
                                            onChange={(event) =>
                                                this.handleChange(event, "amount", "invoiceDetails")
                                            }
                                        />
                                        {/* <ValidationText error={this.state.validState.error.amount} /> */}
                                    </div>
                                </div>

                                <div className="item-grp !flex !gap-2.5 mt-3">
                                    <div className="input-grp min-w-[40%]">
                                        <label>HSN Code</label>
                                        <input
                                            type="number"
                                            id="hsnCodeName"
                                            name="hsnCodeName"
                                            autoComplete='off'
                                            className={`inputFocus ${this.state.validState?.error?.hsnCodeName ? "errorInput" : ""}`}
                                            value={this.state.invoiceDetails.hsnCodeName}
                                            onChange={(event) =>
                                                this.handleChange(event, "hsnCodeName", "invoiceDetails")
                                            }
                                        />
                                        {/* <ValidationText error={this.state.validState.error.hsnCodeName} /> */}
                                    </div>
                                    <div className="input-grp w-full">
                                        <label>SGST [%]</label>
                                        <input className="inputFocus"
                                            type="number"
                                            id="sgst"
                                            name="sgst"
                                            autoComplete='off'
                                            value={this.state.invoiceDetails.sgst}
                                            onChange={(event) =>
                                                this.handleChange(event, "sgst", "invoiceDetails")
                                            }
                                        />
                                    </div>
                                    <div className="input-grp w-full">
                                        <label>CGST [%]</label>
                                        <input className="inputFocus"
                                            type="number"
                                            id="cgst"
                                            name="cgst"
                                            autoComplete='off'
                                            value={this.state.invoiceDetails.cgst}
                                            onChange={(event) =>
                                                this.handleChange(event, "cgst", "invoiceDetails")
                                            }
                                        />
                                    </div>
                                    <div className="input-grp w-full">
                                        <label>IGST [%]</label>
                                        <input className="inputFocus"
                                            type="number"
                                            id="igst"
                                            name="igst"
                                            autoComplete='off'
                                            value={this.state.invoiceDetails.igst}
                                            onChange={(event) =>
                                                this.handleChange(event, "igst", "invoiceDetails")
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="item-grp !flex !gap-2.5 mt-3">
                                    <div className="input-grp min-w-[40%]">
                                        <label>Taxable Amount</label>
                                        <input
                                            type="number"
                                            id="taxableAmount"
                                            name="taxableAmount"
                                            className='inputFocus'
                                            autoComplete='off'
                                            disabled
                                            value={this.state.invoiceDetails.taxableAmount}
                                            onChange={(event) =>
                                                this.handleChange(event, "taxableAmount")
                                            }
                                        />
                                    </div>
                                    <div className="input-grp w-full">
                                        <label>SGST Amount</label>
                                        <input className="inputFocus"
                                            type="number"
                                            id="sgstAmount"
                                            name="sgstAmount"
                                            autoComplete='off'
                                            disabled
                                            value={this.state.invoiceDetails.sgstAmount}
                                            onChange={(event) =>
                                                this.handleChange(event, "sgstAmount")
                                            }
                                        />
                                    </div>
                                    <div className="input-grp w-full">
                                        <label>CGST Amount</label>
                                        <input className="inputFocus"
                                            type="number"
                                            id="cgstAmount"
                                            name="cgstAmount"
                                            disabled
                                            autoComplete='off'
                                            value={this.state.invoiceDetails.cgstAmount}
                                            onChange={(event) =>
                                                this.handleChange(event, "cgstAmount")
                                            }
                                        />
                                    </div>
                                    <div className="input-grp w-full">
                                        <label>IGST Amount</label>
                                        <input className="inputFocus"
                                            type="number"
                                            id="igstAmount"
                                            name="igstAmount"
                                            autoComplete='off'
                                            disabled
                                            value={this.state.invoiceDetails.igstAmount}
                                            onChange={(event) =>
                                                this.handleChange(event, "igstAmount")
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="item-grp !flex !gap-2.5 mt-3">
                                    <div className="input-grp w-full">
                                        <label>Freight (+)</label>
                                        <input
                                            type="number"
                                            id="freight"
                                            name="freight"
                                            className="inputFocus w-full"
                                            autocomplete="off"
                                            value={this.state.invoiceDetails.freight}
                                            onChange={(event) =>
                                                this.handleChange(event, "freight", "invoiceDetails")
                                            }
                                        />
                                    </div>
                                    <div className="input-grp w-full">
                                        <label>Others</label>
                                        <input
                                            type="number"
                                            id="others"
                                            name="others"
                                            className="inputFocus w-full"
                                            autocomplete="off"
                                            value={this.state.invoiceDetails.others}
                                            onChange={(event) =>
                                                this.handleChange(event, "others", "invoiceDetails")
                                            }
                                        />
                                    </div>
                                    <div className="input-grp min-w-[19.4%]">
                                        <label>Round Off</label>
                                        <input
                                            type="number"
                                            id="roundOff"
                                            name="roundOff"
                                            className="inputFocus w-full"
                                            autocomplete="off"
                                            value={this.state.invoiceDetails.roundOff}
                                            onChange={(event) =>
                                                this.handleChange(event, "roundOff", "invoiceDetails")
                                            }
                                            disabled
                                        />
                                    </div>
                                    <div className="input-grp min-w-[39.4%]">
                                        <label>Grand Total</label>
                                        <input
                                            type="text"
                                            id="grandTotal"
                                            name="grandTotal"
                                            autocomplete="off"
                                            disabled
                                            value={this.state.invoiceDetails.grandTotal}
                                            onChange={(event) =>
                                                this.handleChange(event, "grandTotal", "invoiceDetails")
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="btn-grp flex gap-2.5 mt-5">
                                    {this.state.isEditing ?
                                        <button
                                            className="add-btn"
                                            onClick={() => this.addEditGSTPurchaseEntryWithoutInventory()}
                                            disabled={this.state.isLoading}
                                        >
                                            {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                                        </button> :
                                        <button
                                            className="add-btn"
                                            onClick={() => this.addEditGSTPurchaseEntryWithoutInventory()}
                                            disabled={this.state.isLoading}
                                        >
                                            {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                                        </button>
                                    }
                                    <button
                                        className="cancel-btn"
                                        onClick={this.openGridView}
                                        disabled={this.state.isLoading}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </>
                ) : null
                }

            </div>
        );
    }
}

export default GstPurchaseEntryWithoutInventory;